import { render, staticRenderFns } from "./Formacion.vue?vue&type=template&id=c630756e&scoped=true&"
import script from "./Formacion.vue?vue&type=script&lang=js&"
export * from "./Formacion.vue?vue&type=script&lang=js&"
import style0 from "./Formacion.vue?vue&type=style&index=0&id=c630756e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c630756e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCol,VContainer,VRow,VSimpleTable})
